export function useAuthError(trPrefix: string) {
  const { t } = useI18n()

  function getErrorMessage(error: unknown) {
    const key = isAuthError(error) ? error.key : 'unknownError'

    return t(`${trPrefix}${key}` as TranslationKey)
  }

  return { getErrorMessage }
}
